import { on } from '@ember/modifier';
import { action } from '@ember/object';
import { next } from '@ember/runloop';
import Component from '@glimmer/component';

import themed from 'webapp/decorators/themed';
import didUpdate from 'webapp/modifiers/did-update';
import CommonUiIconComponent from 'webapp/components/common/ui-icon';
import FormSelectComponent from 'webapp/components/form/select';
import ToolTipComponent from 'webapp/components/tool-tip';

import type { FilterIdType } from 'webapp/models-custom/filter-sort/base';
import type { AnyFilter } from 'webapp/models-custom/filter-sort/filter';

interface Args {
	model: AnyFilter<FilterIdType>;
	isSortBySearchPointsArray: boolean;
	theme: string;
	onOpenFilterDropdown: (filter: AnyFilter<FilterIdType>) => void;
}

@themed()
export default class FilterLineItemComponent extends Component<Args> {
	declare themeClass: string; // from @themed

	get optionsForDropdown() {
		return this.args.model.optionsForDropdown as { value: FilterIdType; label: string }[];
	}

	get shouldShowTooltip(): boolean {
		// show tooltip only if there are selected options and more than one option is selected
		return this.args.model.selected.length > 1;
	}

	get tooltipText(): string {
		const model = this.args.model;
		const selectedOptions = model.selectedData;

		if (!selectedOptions || !Array.isArray(selectedOptions)) {
			return '';
		}

		const selectedTexts = selectedOptions.map((option) => option.text);
		return selectedTexts.join('<br>');
	}

	@action
	checkSelected(): void {
		const model = this.args.model;
		if (model.selected && !model.isDefaultSelected && !model.selectedData) {
			next(model, model.checkSelected);
		}
	}

	@action
	openFilterDropdown(): void {
		this.args.onOpenFilterDropdown(this.args.model);
	}

	@action
	select(value: string | number | string[] | number[] | null): void {
		this.args.model.selectOption(value!);
	}
	<template>
		<div
			class="filterSwitcher
				{{this.themeClass}}
				f{{@model.id}}
				{{unless @model.isShown 'hidden'}}
				{{if @model.isActive 'active'}}"
			{{didUpdate this.checkSelected @model.selectedData}}
		>
			{{#if @model.isShown}}
				<span>{{@model.label}}</span>

				{{#if @model.isSelectDropdown}}
					<div class="dropdown">
						<FormSelectComponent
							name="filterDropdown{{@model.id}}"
							{{! @glint-ignore: select typings all over the place }}
							@selected={{@model.selected}}
							{{! @glint-ignore: select typings all over the place }}
							@options={{this.optionsForDropdown}}
							@onChange={{this.select}}
							@isNumeric={{@model.isNumeric}}
							@isMultiple={{@model.isMultiSelect}}
							@size="small"
							@isRequired={{true}}
							@showFloatlabel={{false}}
						/>
					</div>
				{{else}}
					<a
						role="button"
						class={{if @model.isActive "em"}}
						{{on "click" this.openFilterDropdown}}
					>
						{{#if @isSortBySearchPointsArray}}
							<div>Search relevance</div>
						{{else if @model.selectedDisplayText}}
							<div>{{@model.selectedDisplayText}}</div>
						{{/if}}
						<CommonUiIconComponent @name="ChevronDown" @size="sm" />
					</a>
				{{/if}}

				{{#if this.shouldShowTooltip}}
					<ToolTipComponent @text={{this.tooltipText}} />
				{{/if}}
			{{/if}}
		</div>
	</template>
}
